import React from 'react'

import PaymentMethodsContext from 'contexts/PaymentMethodsContext'
import useBeforeunload from 'hooks/useBeforeunload'

const PaymentMethodsProvider = ({ children }) => {
  const [data, setData] = React.useState({
    integrationToken: {},
    selectMethods: {},
    configuration: {},
  })
  const [error, setError] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [
    isLoadingIntegrationToken,
    setIsLoadingIntegrationToken,
  ] = React.useState(true)
  const [isLoadingPaymentMethods, setIsLoadingPaymentMethods] = React.useState(
    true,
  )

  React.useEffect(() => {
    if (isLoadingIntegrationToken || isLoadingPaymentMethods) {
      setIsLoading(true)
      return
    }

    setIsLoading(false)
  }, [isLoadingIntegrationToken, isLoadingPaymentMethods])

  useBeforeunload(() => {
    return 'Sair do site?'
  })

  return (
    <PaymentMethodsContext.Provider
      value={{
        data,
        setData,
        error,
        setError,
        isLoading,
        setIsLoading,
        isLoadingIntegrationToken,
        setIsLoadingIntegrationToken,
        isLoadingPaymentMethods,
        setIsLoadingPaymentMethods,
      }}
    >
      {children}
    </PaymentMethodsContext.Provider>
  )
}

export default PaymentMethodsProvider
